import { Skeleton } from '@/shared/components/ui/skeleton';

/**
 * The office map's card while its layout loads: the floor at the height the booking page gives
 * the map, then the filters and zoom buttons below it.
 */
export function OfficeMapSkeleton() {
  return (
    <div className="@container w-full rounded-xl bg-card shadow-sm">
      <div className="h-80 p-4 sm:h-[clamp(340px,68vh,640px)] 2xl:h-[clamp(340px,85vh,960px)]">
        <Skeleton className="size-full rounded-lg" />
      </div>
      <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 px-3 py-2.5 @max-md:gap-x-1.5 @max-md:px-2">
        <Skeleton className="h-8 w-64 rounded-lg @max-md:h-7 @max-md:w-52" />
        <Skeleton className="h-8 w-32 rounded-lg @max-md:h-7 @max-md:w-28" />
      </div>
    </div>
  );
}
